import Events from '@/events';
import { defineComponent } from 'vue';
import EventBus from '@/eventBus';
import JdeCustomerInfo from '@/models/distributor/jdeCustomerInfo';
import SalesAgencyAddress from '@/models/distributor/SalesAgencyAddress';
import hadrianModal from '../hadrianModal/hadrianModal.vue';
import companyIcon from '@/shared/icons/company/company.vue';
import iconMail from '@/shared/icons/mail/mail.vue';
import iconContact from '@/shared/icons/contact/contact.vue';
import userIcon from '@/shared/icons/user/user.vue';
import { ModalVariant } from '../hadrianModal/hadrianModal';

interface OrgContactInfoPayload {
  jdeCustomerInfo: JdeCustomerInfo;
  salesAgencyAddress: SalesAgencyAddress;
}

interface ContactEntry {
  name: string;
  email: string;
  phone: string;
}

export default defineComponent({
  name: 'organizationContactInfoModal',
  components: {
    hadrianModal,
    companyIcon,
    iconMail,
    iconContact,
    userIcon,
  },
  data() {
    return {
      contactInfo: null as OrgContactInfoPayload | null,
      ModalVariant,
    };
  },
  created() {
    EventBus.$on(Events.showOrgCompleteContactInfo, this.openModal);
  },
  beforeUnmount() {
    EventBus.$off(Events.showOrgCompleteContactInfo, this.openModal);
  },
  computed: {
    salesAgentInfo(): ContactEntry {
      return {
        name: this.contactInfo?.salesAgencyAddress?.organizationName ?? '',
        email: this.contactInfo?.salesAgencyAddress?.address?.contactEmail ?? '',
        phone: this.contactInfo?.salesAgencyAddress?.address?.contactPhone ?? '',
      };
    },
    customerServiceInfo(): ContactEntry {
      return {
        name: this.contactInfo?.jdeCustomerInfo?.jdeCerRepName ?? '',
        email: this.contactInfo?.jdeCustomerInfo?.jdeCerRepEmail ?? '',
        phone: this.contactInfo?.jdeCustomerInfo?.jdeCerRepPhoneNumber ?? '',
      };
    },
    territoryManagerInfo(): ContactEntry {
      return {
        name: this.contactInfo?.jdeCustomerInfo?.rsmName ?? '',
        email: this.contactInfo?.jdeCustomerInfo?.rsmEmail ?? '',
        phone: this.contactInfo?.jdeCustomerInfo?.rsmPhoneNumber ?? '',
      };
    },
    contactSections(): { title: string; icon: string; name: string; email: string; phone: string }[] {
      return [
        {
          title: this.$t('modal.organizationContactInfoModal.agentTitle'),
          icon: 'companyIcon',
          ...this.salesAgentInfo,
        },
        {
          title: this.$t('modal.organizationContactInfoModal.customerServiceRepTitle'),
          icon: 'userIcon',
          ...this.customerServiceInfo,
        },
        {
          title: this.$t('modal.organizationContactInfoModal.rsmTitle'),
          icon: 'userIcon',
          ...this.territoryManagerInfo,
        },
      ];
    },
  },
  methods: {
    cancel() {
      (this.$refs.organizationContactInfoModal as any).hide();
    },
    openModal(payload: OrgContactInfoPayload) {
      this.contactInfo = payload;
      (this.$refs.organizationContactInfoModal as any).show();
    },
  },
});
